import { gql } from '@apollo/client';

export const orderMultiTripQuery = gql`
  mutation Order(
    $comparisonId: UUID!
    $chosenProductKrn: String!
    $frontEndName: String
    $policy: MultiTripTravel_PolicyDetailsInput!
    $sessionId: String
    $clientId: String
    $googleAnalyticsId: String
    $googleAnalyticsSessionId: String
  ) {
    orderMultiTripTravel(
      input: {
        comparisonId: $comparisonId
        chosenProductKrn: $chosenProductKrn
        frontEndName: $frontEndName
        request: {
          policyPolicyDetails: [$policy]
          commonTechnical: {
            senderId: $clientId
            sessionId: $sessionId
            googleAnalyticsId: $googleAnalyticsId
            googleAnalyticsSessionId: $googleAnalyticsSessionId
          }
        }
      }
    ) {
      multiTripTravel_OrderResult {
        orderId
      }
      errors {
        ... on MultiTripTravel_IGraphQlErrorBase {
          type
          message
        }
      }
    }
  }
`;
